module.exports = __webpack_public_path__ + "img/020088.10b88d0a.png";